import { path } from 'd3';
import { SideBarRoutes } from 'features/sidebar/types/SideBarRoutes';

export const sidebarRoutes: SideBarRoutes[] = [
  {
    label: 'Dashboard',
    path: 'dashboard',
    children: [],
    active: false
  },
  {
    label: 'Advanced Reports',
    path: 'advanced-reports',
    children: [],
    active: false
  },
  {
    label: 'Reports',
    active: false,
    children: [
      {
        label: 'Source',
        path: 'reports/source'
      },
      {
        label: 'Keyword',
        path: 'reports/keywords'
      },
      {
        label: 'Landing Page',
        path: 'reports/landing-page'
      },
      {
        label: 'Referrer',
        path: 'reports/referrer'
      },
      {
        label: 'UTM Campaign',
        path: 'reports/utm-campaign'
      },
      {
        label: 'UTM Medium',
        path: 'reports/utm-medium'
      },
      {
        label: 'UTM Content',
        path: 'reports/utm-content'
      },
      {
        label: 'Browser',
        path: 'reports/browser'
      },
      {
        label: 'OS',
        path: 'reports/os'
      },
      {
        label: 'Device',
        path: 'reports/device'
      }
    ]
  },
  {
    label: 'Conversions',
    active: false,
    children: [
      {
        label: 'Form',
        path: 'conversions/forms'
      },
      {
        label: 'Phone Call',
        path: 'conversions/phone-calls'
      }
    ]
  },
  {
    label: 'Revenue',
    active: false,
    path: 'revenue',
    children: []
  },
  {
    label: 'Opportunities',
    active: false,
    path: 'opportunities',
    children: []
  },
  {
    label: 'Paths',
    active: false,
    path: 'paths',
    children: []
  },
  {
    label: 'Marketing Mix Modelling',
    active: false,
    path: 'marketing-mix-modelling',
    poc: true,
    whiteListedSites: ['641d914945eb2', 'demo'],
    children: [
      {
        label: 'Modelled ROI',
        path: 'marketing-mix-modelling/modelled-roi'
      },
      {
        label: 'Budget Optimiser',
        path: 'marketing-mix-modelling/budget-optimiser'
      },
      {
        label: 'Budget Scenario Planner',
        path: 'marketing-mix-modelling/budget-scenario-planner'
      },
      {
        label: 'Campaign Budget Scenario Planner',
        path: 'marketing-mix-modelling/campaign-budget-scenario-planner'
      }
    ]
  }
];
